import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class DeactivateInvestorGoalError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('DeactivateGoalError', ...args);
    }
}
export default DeactivateInvestorGoalError;
